export default __webpack_public_path__ + "static/media/a3.ad5f5f31.png";